import * as models from './model';

export interface MatchNav {
    title?: string;
    navigationId?: string;
}
